import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { _QueryResource, _QueryResources } from '@/lib/datx-jsonapi-react';
import { EventSponsor } from '@/resources/EventSponsor';

export const queryEventSponsorsWithFilters = (filters = {}): _QueryResources<EventSponsor> => {
  return [
    EventSponsor,
    {
      filter: omitBy(
        {
          ...omitBy(filters, isNil),
        },
        isNil
      ),
    },
  ];
};

export const queryEventSponsor = (id: string): _QueryResource<EventSponsor> => {
  return id ? [EventSponsor, id] : null;
};
